export default __webpack_public_path__ + "static/media/sekerayse7.38bb77b4.jpg";